import { useEffect, useState } from "react";

/**
 * Returns `true` while a CSS media query matches, and re-renders when it
 * changes (e.g. when the window is resized or the device rotated).
 *
 *   const isDesktop = useMediaQuery("(min-width: 900px)");
 */
export default function useMediaQuery(query) {
  // Some environments (old browsers, the test runner) lack matchMedia.
  const supported = typeof window !== "undefined" && !!window.matchMedia;
  const getMatch = () => supported && window.matchMedia(query).matches;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (!supported) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query, supported]);

  return matches;
}
